import { MarketingLayout } from "../../components/marketing/marketing-layout";
import { featuresContent } from "../../content/marketing/features";
import { usePageMeta } from "../../hooks/use-page-meta";

export default function FeaturesPage() {
  usePageMeta(featuresContent.metaTitle, featuresContent.metaDescription);

  return (
    <MarketingLayout>
      <section className="mx-auto flex max-w-[65ch] flex-col gap-4 px-4 py-16 text-center md:px-6 md:py-24">
        <h1 className="font-bold font-display text-3xl md:text-4xl">
          {featuresContent.heading}
        </h1>
        <p className="text-base text-muted-foreground">
          {featuresContent.intro}
        </p>
      </section>

      {featuresContent.clusters.map((cluster, index) => (
        <section
          className="mx-auto max-w-5xl px-4 pb-16 md:px-6 md:pb-24"
          key={cluster.heading}
        >
          <h2 className="mb-6 text-center font-bold font-display text-2xl md:text-3xl">
            {cluster.heading}
          </h2>
          {cluster.image && (
            <picture>
              <source
                media="(min-width: 768px)"
                srcSet={`/images/marketing/${cluster.image.baseName}-desktop.webp`}
                type="image/webp"
              />
              <source
                media="(min-width: 768px)"
                srcSet={`/images/marketing/${cluster.image.baseName}-desktop.png`}
                type="image/png"
              />
              <source
                srcSet={`/images/marketing/${cluster.image.baseName}-mobile.webp`}
                type="image/webp"
              />
              {/* biome-ignore lint/nursery/useImageSize: same portrait/landscape
              breakpoint swap as the landing hero — see that component's
              comment for why a single width/height pair can't apply here. */}
              <img
                alt={cluster.image.alt}
                className="mb-6 aspect-[390/844] w-full rounded-lg border border-border object-cover md:aspect-[16/9]"
                loading={index === 0 ? "eager" : "lazy"}
                src={`/images/marketing/${cluster.image.baseName}-mobile.png`}
              />
            </picture>
          )}
          <div className="grid gap-6 md:grid-cols-2">
            {cluster.items.map((item) => (
              <div
                className="flex flex-col gap-2 rounded-lg border border-border p-6"
                key={item.title}
              >
                <h3 className="font-semibold text-lg">{item.title}</h3>
                <p className="text-muted-foreground text-sm">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </section>
      ))}
    </MarketingLayout>
  );
}
